import { FC, PropsWithChildren } from 'react';
import ShadowBox from '@/common/components/general/ShadowBox';
import info from 'common/assets/svg/common/info.svg';
import SvgRender from '@/library/components/general/SvgRender';

type InfoPanelProps = {
  className?: string;
  size?: 'sm' | 'md';
};

const InfoPanel: FC<PropsWithChildren<InfoPanelProps>> = ({ children, className, size = 'md' }) => {
  return (
    <ShadowBox
      className={`${size === 'sm' ? 'cpx-12 cpy-4' : 'cp-12'} fs-12 text-violet d-flex flex-nowrap rounded-xl ${className || ''}`}
      color="mystic"
      flat
    >
      <div className="pe-1 cpt-2">
        <SvgRender style={{ width: 12, height: 12 }} src={info} />
      </div>
      <div className="flex-1 overflow-hidden">{children}</div>
    </ShadowBox>
  );
};

export default InfoPanel;
